import RaceReservationsCartItem from './race-reservations-cart-item'
import RacesCartItem from './races-cart-item'
import GiftCardsCartItem from './gift-cards-cart-item'
import FreePromoLinkedGiftCardsCartItem from './free-promo-linked-gift-cards-cart-item'
import PlaycardVoucherCartItem from './playcard-voucher-cart-item'
import PlaycardReloadCartItem from './playcard-reload-cart-item'
import AccessoriesCartItem from './accessories-cart-item'

// @deprecated: Use EventReservationCartItem instead
import EventReservationAxeThrowingCartItem from './event-reservation-axe-throwing-cart-item'

import EventReservationCartItem from './event-reservation-cart-item'

export default {
  RacesCartItem,
  RaceReservationsCartItem,
  GiftCardsCartItem,
  FreePromoLinkedGiftCardsCartItem,
  PlaycardVoucherCartItem,
  PlaycardReloadCartItem,
  AccessoriesCartItem,
  EventReservationAxeThrowingCartItem,
  EventReservationCartItem
}
